import { render, staticRenderFns } from "./barrasProgreso.vue?vue&type=template&id=39f7cb87&scoped=true&"
import script from "./barrasProgreso.vue?vue&type=script&lang=js&"
export * from "./barrasProgreso.vue?vue&type=script&lang=js&"
import style0 from "./barrasProgreso.vue?vue&type=style&index=0&id=39f7cb87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f7cb87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VChip,VDivider,VProgressLinear})
